import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const TagsListPage = lazy(() =>
  import('../../pages/settings/tags/TagsListPage').then((m) => ({
    default: m.TagsListPage,
  })),
);

export const Route = createFileRoute('/settings/tags')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <TagsListPage />
    </Suspense>
  ),
});
